import { Link, NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.jsx';
import { Avatar } from './Avatar.jsx';

export function AdminLayout() {
    const { user, logout } = useAuth();

    return (
        <div className="min-h-screen flex flex-col">
            <header
                style={{
                    background: 'var(--color-bg-primary)',
                    borderBottom: '0.5px solid var(--color-border-tertiary)',
                }}
            >
                <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between">
                    <div className="flex items-center" style={{ gap: 24 }}>
                        <Link to="/admin"
                            style={{ fontSize: 15, fontWeight: 500, color: 'var(--color-text-primary)' }}>
                            Stars APT · Admin
                        </Link>
                        <nav className="flex items-center" style={{ gap: 4 }}>
                            <NavItem to="/admin" end>Dashboard</NavItem>
                            <NavItem to="/admin/presence">Live presence</NavItem>
                            <NavItem to="/admin/leave">Leave queue</NavItem>
                            <NavItem to="/admin/employees">Employees</NavItem>
                            <NavItem to="/admin/holidays">Holidays</NavItem>
                        </nav>
                    </div>
                    <div className="flex items-center" style={{ gap: 12 }}>
                        <Avatar user={user} size="sm" />
                        <span style={{ fontSize: 13, color: 'var(--color-text-secondary)' }}>{user?.name}</span>
                        <button onClick={logout} className="btn btn-ghost" style={{ padding: '6px 10px' }}>
                            Sign out
                        </button>
                    </div>
                </div>
            </header>

            <main className="flex-1 max-w-6xl w-full mx-auto px-4 py-6">
                <Outlet />
            </main>
        </div>
    );
}

function NavItem({ to, end, children }) {
    return (
        <NavLink
            to={to}
            end={end}
            style={({ isActive }) => ({
                padding: '6px 12px',
                fontSize: 13,
                fontWeight: isActive ? 500 : 400,
                borderRadius: 'var(--border-radius-md)',
                color: isActive ? 'var(--color-text-primary)' : 'var(--color-text-secondary)',
                background: isActive ? 'var(--color-bg-secondary)' : 'transparent',
                transition: 'background-color 120ms ease, color 120ms ease',
                textDecoration: 'none',
            })}
        >
            {children}
        </NavLink>
    );
}
